export const METADATA_IMAGE_TEXT_SPACING = 'var(--metadata-image-text-spacing)';
export const FOOTER_ACTION_COMPACT_ICON_SIZE = 'var(--footer-action-compact-icon-size)';
export const FOOTER_ACTION_ELLIPSIS_ICON_SIZE = 'var(--footer-action-ellipsis-icon-size)';
export const FOOTER_ACTION_ICON_FRAME_SIZE = 'var(--footer-action-icon-frame-size)';
export const FOOTER_ACTION_BUTTON_SPACING = 'var(--footer-action-button-spacing)';
